module.exports = __webpack_public_path__ + "img/check.c5a11f27.svg";